/** Calendar dates are business-local labels, never browser-local instants. */
export function isoToday(): string {
	return new Date().toLocaleDateString("en-CA", {
		timeZone: "Australia/Adelaide",
	});
}

export function shiftMonth(month: string, delta: number): string {
	const [year, mon] = month.split("-").map(Number);
	const date = new Date(Date.UTC(year, mon - 1 + delta, 1));
	return date.toISOString().slice(0, 7);
}

/** Shift a business-local ISO date without involving the browser timezone. */
export function shiftDate(date: string, deltaDays: number): string {
	const shifted = new Date(`${date}T00:00:00Z`);
	shifted.setUTCDate(shifted.getUTCDate() + deltaDays);
	return shifted.toISOString().slice(0, 10);
}

/** Monday-first seven-day range containing the supplied business-local date. */
export function weekGrid(date: string): string[] {
	const anchor = new Date(`${date}T00:00:00Z`);
	const mondayOffset = (anchor.getUTCDay() + 6) % 7;
	const monday = shiftDate(date, -mondayOffset);
	return Array.from({ length: 7 }, (_, index) => shiftDate(monday, index));
}

export function weekBounds(date: string): { from: string; to: string } {
	const days = weekGrid(date);
	return { from: days[0], to: days[6] };
}

/** Only the weeks needed to display the month, including spillover dates. */
export function monthGrid(month: string): string[] {
	const first = new Date(`${month}-01T00:00:00Z`);
	const offset = (first.getUTCDay() + 6) % 7;
	const last = new Date(
		Date.UTC(first.getUTCFullYear(), first.getUTCMonth() + 1, 0),
	);
	const count = Math.ceil((offset + last.getUTCDate()) / 7) * 7;
	return Array.from({ length: count }, (_, index) => {
		const date = new Date(first);
		date.setUTCDate(1 - offset + index);
		return date.toISOString().slice(0, 10);
	});
}

/** Fetch exactly the displayed grid, so adjacent-month cells are truthful. */
export function monthBounds(month: string): { from: string; to: string } {
	const days = monthGrid(month);
	return { from: days[0], to: days[days.length - 1] };
}

export function formatDate(date: string): string {
	return new Intl.DateTimeFormat("en-AU", {
		weekday: "short",
		day: "numeric",
		month: "short",
		year: "numeric",
		timeZone: "UTC",
	}).format(new Date(`${date}T00:00:00Z`));
}

/** Preserve quarter-hour precision without rounding 15 minutes to 0.3 hours. */
export function formatStaffHours(minutes: number): string {
	return `${Number((minutes / 60).toFixed(2))} staff-hours`;
}
